<template>
  <div>
    <v-text-field
      v-if="mask"
      :label="postalCodeLabel"
      @input="onInput"
      v-bind="$attrs"
      v-on="$listeners"
      v-mask="{ mask: [...mask], tokens: tokens }"
      :rules="rulesArray"
    ></v-text-field>
    <v-text-field v-else @input="onInput" v-bind="$attrs" v-on="$listeners" :rules="rulesArray"></v-text-field>
  </div>
</template>

<script>
export default {
  name: "PostalCodeField",
  data: () => ({
    mask: null,
    rulesArray: [],
    tokens: {
      "#": { pattern: /\d/ },
      X: { pattern: /[0-9a-zA-Z]/, transform: v => v.toLocaleUpperCase() },
      S: { pattern: /[a-zA-Z]/ },
      A: { pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase() },
      a: { pattern: /[a-zA-Z]/, transform: v => v.toLocaleLowerCase() },
      "!": { escape: true }
    }
  }),
  props: {
    country: Object,
    rules: Array,
    label: String
  },
  methods: {
    onInput(obj) {
      this.$emit("input", obj);
    },
    validate(postalCode) {
      if (this.country && this.country.postalCodeRegex && !!postalCode) {
        let regex = RegExp(this.country.postalCodeRegex);
        if (!regex.test(postalCode)) {
          return "Invalid " + this.country.name + " Postal Code";
        }
      }
      return true;
    },
    resetRulesArray() {
      this.rulesArray = [];
      if (this.rules) {
        this.rulesArray = this.rulesArray.concat(this.rules);
      }
      if (this.country && this.country.postalCodeMask) {
        this.mask = this.country.postalCodeMask;
        this.rulesArray = this.rulesArray.concat(this.validate);
      }
    }
  },
  watch: {
    country: function() {
      if (this.country && this.country.postalCodeMask) {
        this.mask = this.country.postalCodeMask;
      }
      this.resetRulesArray();
    }
  },
  mounted() {
    this.resetRulesArray();
  },
  computed: {
    postalCodeLabel() {
      if (this.label) return this.label;
      if (this.country) {
        return this.country.postalCodeName;
      }
      return "Postal Code";
    }
  }
};
</script>
